import React from "react";
import {
  HotspotIcon,
  LocationQuestionIcon,
  UserFilledIcon,
  homeTabIcons,
} from "../../../Diathrive/src/utils/SvgIcons";
import RightChevronIcon from "../../assets/svg-icons/RightChevronIcon";
import BloodSugarGraphIcon from "../../assets/svg-icons/BloodSugarGraphIcon";
import SettingsIcon from "../../assets/svg-icons/SettingsIcon";
import UsersFilledIcon from "../../assets/svg-icons/UsersFilledIcon";
import BloodFilledIcon from "../../assets/svg-icons/BloodFilledIcon";
import MapLocationFilledIcon from "../../assets/svg-icons/MapLocationFilledIcon";
import MoneyFilledIcon from "../../assets/svg-icons/MoneyFilledIcon";
import { COLORS } from "../../../Diathrive/src/utils/Constants";

export const sidePannelIcons = {
  home: homeTabIcons.home,
  homeActive: homeTabIcons.homeFilled,
  resources: homeTabIcons.resources,
  resourcesActive: homeTabIcons.resourcesFilled,
  store: homeTabIcons.shopping,
  storeActive: homeTabIcons.shoppingFilled,
  advising: homeTabIcons.advising,
  advisingActive: homeTabIcons.advisingFilled,
  bloodSugar: <BloodSugarGraphIcon />,
  bloodSugarActive: <BloodSugarGraphIcon tintColor={COLORS.mainLargeText} />,
  settings: <SettingsIcon />,
  settingActive: <SettingsIcon tintColor={COLORS.mainLargeText} />,
  help: <LocationQuestionIcon tintColor={COLORS.grey2} />,
  helpActive: <LocationQuestionIcon tintColor={COLORS.mainLargeText} />,
};

export const settingsIcons = {
  profile: <UserFilledIcon tintColor={COLORS.black} />,
  wallet: <MoneyFilledIcon />,
  address: <MapLocationFilledIcon />,
  sugarRange: <BloodFilledIcon />,
  contacts: <UsersFilledIcon />,
  devices: <HotspotIcon />,
};

export { RightChevronIcon };
